// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import 'select2'
import $ from 'jquery';
import select2 from 'select2';




Rails.start()
Turbolinks.start()
ActiveStorage.start()

require('packs/bootstrap.bundle.min')
require('packs/function')

$( document ).on('turbolinks:load', function() { 
$('.select_single').select2({
    allowClear:false
 });
$('.tag_select').select2({
    allowClear:false,
    tags: true,
    tokenSeparators: [',']
 });



 setTimeout(function(){
    $('.alert').fadeOut();
  }, 10000);
});
